import React, { useState, useEffect } from 'react';
import { analyticsService } from '../../services/analyticsService';
import { AnalyticsOverview } from './Analytics/AnalyticsOverview';
import { InspectionAnalytics } from './Analytics/InspectionAnalytics';
import { QuoteAnalytics } from './Analytics/QuoteAnalytics';
import { TimeFilter } from './Analytics/TimeFilter';
import { BarChart2, RefreshCw } from 'lucide-react';
import { useLanguage } from '../../hooks/useLanguage';

export const Analytics = () => {
    const { t, isRTL } = useLanguage();
    const [period, setPeriod] = useState('month');
    const [analytics, setAnalytics] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        loadAnalytics();
    }, [period]);

    const loadAnalytics = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await analyticsService.getAnalytics(period);
            setAnalytics(data);
        } catch (error) {
            console.error('Erreur lors du chargement des analytiques:', error);
            setError(t('analytics.messages.error'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={`space-y-6 ${isRTL ? 'rtl' : ''}`}>
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-gray-800">
                    {t('analytics.title')}
                </h1>
                <div className={`flex items-center ${isRTL ? 'space-x-reverse' : ''} space-x-4`}>
                    <TimeFilter value={period} onChange={setPeriod} />
                    <button
                        onClick={loadAnalytics}
                        className="p-2 rounded-md hover:bg-gray-100"
                        title={t('analytics.actions.refresh')}
                    >
                        <RefreshCw className="h-5 w-5 text-gray-500" />
                    </button>
                </div>
            </div>

            {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative">
                    {error}
                </div>
            )}

            {loading ? (
                <div className="flex justify-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
                </div>
            ) : analytics && (
                <div className="space-y-6">
                    <AnalyticsOverview data={analytics.overview} />

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <InspectionAnalytics data={analytics.inspections} />
                        <QuoteAnalytics data={analytics.quotes} />
                    </div>
                </div>
            )}
        </div>
    );
};